/**
 * Color-coded task priority chip — High (red), Medium (amber), Low (slate).
 */
export const PRIORITY_OPTIONS = ["Low", "Medium", "High"];

const PRIORITY_STYLES = {
  High:   { bg: "#fee2e2", fg: "#b91c1c", border: "#fca5a5" },
  Medium: { bg: "#fef3c7", fg: "#b45309", border: "#fcd34d" },
  Low:    { bg: "#e2e8f0", fg: "#475569", border: "#cbd5e1" },
};

export default function PriorityChip({ priority }) {
  const p = priority || "Medium";
  const s = PRIORITY_STYLES[p] || PRIORITY_STYLES.Medium;
  return (
    <span
      className="inline-block text-[10px] font-semibold px-2 py-0.5 rounded-sm border uppercase tracking-wide"
      style={{ background: s.bg, color: s.fg, borderColor: s.border }}
      data-testid={`priority-chip-${p.toLowerCase()}`}
    >
      {p}
    </span>
  );
}
